// extracted by mini-css-extract-plugin
export default {"caption":"index_caption__JuTJ9","content":"index_content__Foo66","btnBar":"index_btnBar__lFKvk","step":"index_step__n0+vv"};